import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import { Turbo, cable } from "@hotwired/turbo-rails"
import { createConsumer } from "@rails/actioncable"

// Pre-configure the ActionCable consumer for Turbo Streams
// This avoids dynamic import issues with webpack and ensures turbo_stream_from works
cable.setConsumer(createConsumer())

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target)
}

Turbo.StreamActions.close_modal = function () {
  const modal = document.getElementById(this.target)
  if (modal) {
    const bsModal = bootstrap.Modal.getInstance(modal)
    if (bsModal) {
      bsModal.hide()
    }
  }
}

window.Stimulus = Application.start();

// In test environment, rethrow Stimulus errors so Capybara can catch them
if (process.env.RAILS_ENV === "test") {
  window.Stimulus.handleError = (error, message, detail) => {
    console.error(message, error, detail)
    // Use setTimeout to throw asynchronously - this allows Cuprite to catch it
    // as an uncaught exception without crashing the browser process
    setTimeout(() => { throw error }, 0)
  }
}

const context = require.context("../javascripts/controllers", true, /(?<!\.test)\.(t|j)s$/)
window.Stimulus.load(definitionsFromContext(context))

if (process.env.RAILS_ENV == "development") {
  const events = [
    "turbo:fetch-request-error",
    "turbo:frame-missing",
    "turbo:frame-load",
    "turbo:frame-render",
    "turbo:before-frame-render",
    "turbo:load",
    "turbo:render",
    "turbo:before-stream-render",
    "turbo:before-render",
    "turbo:before-cache",
    "turbo:submit-end",
    "turbo:before-fetch-response",
    "turbo:before-fetch-request",
    "turbo:submit-start",
    "turbo:visit",
    "turbo:before-visit",
    "turbo:click"
  ]

  events.forEach(e => {
    addEventListener(e, () => {
      console.log(e);
    });
  });
}
